import { addDisplayName, addProps, flowMax } from 'ad-hok'
import { FC } from 'react'
import { createUseStyles } from 'react-jss'
import { Link } from 'react-router-dom'

import { Subscribe } from './menu/Subscribe'
import { addTranslationHelpers } from 'utils/addTranslationHelpers'
import { sansSerifFontFamily } from 'utils/styles'

const useStyles = createUseStyles({
  container: {
    height: '100dvh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  backToRodeo: {
    fontFamily: sansSerifFontFamily,
    fontWeight: 700,
    fontSize: 14,
    textDecoration: 'none',
    lineHeight: '187%',
    color: 'rgba(255, 255, 255, 0.8)',
  },
})

export const SubscribePage: FC = flowMax(
  addDisplayName('SubscribePage'),
  addProps(() => ({
    classes: useStyles(),
  })),
  addTranslationHelpers,
  ({ classes, t }) => (
    <div className={classes.container}>
      <Subscribe />
      <Link to="/" className={classes.backToRodeo}>
        {t('menu.subscribe.back')}
      </Link>
    </div>
  )
)
